// extracted by mini-css-extract-plugin
export default {"changeField":"confirmSalePaymentForm_changeField__IRcPQ","optionNote":"confirmSalePaymentForm_optionNote__p6GyT"};